import { render } from "./GMvirtualCommerce.vue?vue&type=template&id=24b1324f&scoped=true"
import script from "./GMvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./GMvirtualCommerce.vue?vue&type=script&lang=js"

import "./GMvirtualCommerce.vue?vue&type=style&index=0&id=24b1324f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24b1324f"

export default script